<template>
  <div id="index">
    <common-header></common-header>
    <p v-if="isLoading" style="text-align:center;margin:30% 0;"><v-progress-circular class="isLoading" :size="70" :width="7" color="primary" indeterminate></v-progress-circular></p>
    <div v-else>
      <!-- メッセージ -->
      <div v-if="isError">
        <v-alert
          :value="true"
          type="error"
          outline
        >
          {{errorMessage}}
        </v-alert>
      </div>
      <!-- /メッセージ -->
      <div style="margin:10px;">
        <v-dialog v-model="dialog" width="500">
        <v-card>
          <v-card-title class="croppa-header primary white--text">
            プロフィール画像選択
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialog=!dialog"><v-icon>close</v-icon></v-btn>
          </v-card-title>
          <div>
            <div class="messageArea">
              <v-alert :value="true" :type="croppaMessageType" outline>
                {{croppaMessage}}
              </v-alert>
            </div>
            <div class="croppa-wrapper">
              <croppa v-model="croppa"
                      :width="200"
                      :height="200"
                      placeholder="画像を選択"
                      placeholder-color="#000"
                      :placeholder-font-size="24"
                      canvas-color="transparent"
                      :show-remove-button="true"
                      remove-button-color="red"
                      :remove-button-size="Number(35)"
                      :show-loading="true"
                      :loading-size="50"
                      :zoom-speed="20"
                      :file-size-limit="2097152"
                      accept="image/png,image/jpeg,image/jpg"
                      @file-type-mismatch="onFileTypeMismatch"
                      @file-size-exceed="onFileSizeExceed"
                      @file-choose="onFileChoosed"
                      @image-remove="onImageRemoved"
              >
              </croppa>
            </div>
            <div class="croppa-compornent">
              <v-btn fab small @click="croppa.zoomOut()"><v-icon>remove</v-icon></v-btn>
              <v-btn fab small @click="croppa.zoomIn()"><v-icon>add</v-icon></v-btn>
            </div>
            <div class="container">
              <v-btn dark color="primary" block large @click="generateImage">画像を設定する</v-btn>
            </div>
          </div>
        </v-card>
      </v-dialog>
      <v-layout row wrapper>
        <v-flex xs4 class="topIcon">
          <v-avatar :size="90" color="grey lighten-4" @click="dialog=!dialog">
            <img :src="imageUrl">
          </v-avatar>
        </v-flex>
        <v-flex xs8>
          <p class="topName">{{userInfo.displayName}}</p>
          <p><v-btn depressed color="primary" @click="dialog=!dialog">画像を変更する</v-btn></p>
        </v-flex>
      </v-layout>
      <v-text-field label="お名前（ニックネーム）" outline v-model="userInfo.displayName"></v-text-field>
      <v-text-field label="URL" placeholder="SNS、ホームページなど" outline v-model="userInfo.url"></v-text-field>
      <v-textarea
            outline
            name="input-7-4"
            label="自己紹介"
            placeholder="ご自由に入力ください"
            v-model="userInfo.introduction"
      ></v-textarea>
      <div class="block" style="border:none;">
        <v-btn block large color="red" dark @click="update">更新</v-btn>
      </div>
    </div>
    </div>
    <common-footer></common-footer>
  </div>
</template>

<script>
import { db } from '../../main'
import firebase from 'firebase'
import CommonHeader from '../common/CommomHeader'
import CommonFooter from '../common/CommomFooter'
export default {
  name: 'EditProfile',
  data () {
    return {
      id: '',
      userInfo: {},
      croppa: {},
      dialog: false,
      croppaMessage: 'タップして画像を選択してください',
      croppaMessageType: 'info',
      imageUrl: '',
      isImageUpdate: false,
      isError: false,
      errorMessage: '',
      isLoading: false
    }
  },
  mounted () {
    this.id = this.$route.params.obj.id
    this.userInfo = this.$route.params.obj.userInfo
    this.imageUrl = this.userInfo.photoURL
  },
  methods: {
    generateImage: function () {
      let url = this.croppa.generateDataUrl()
      if (!url) {
        this.croppaMessageType = 'error'
        this.croppaMessage = '画像が選択されていません。画像を選択してください。'
        return
      }
      this.imageUrl = url
      this.isImageUpdate = true
      this.dialog = false
    },
    onFileTypeMismatch () {
      this.croppaMessageType = 'error'
      this.croppaMessage = 'アップロードできるファイルはjpgまたはpngです。'
    },
    onFileSizeExceed () {
      this.croppaMessageType = 'error'
      this.croppaMessage = 'ファイルサイズが大きすぎます。'
    },
    onFileChoosed () {
      this.croppaMessageType = 'info'
      this.croppaMessage = '画像のズームと位置を調整し、設定ボタンを押してください'
    },
    onImageRemoved () {
      this.croppaMessageType = 'info'
      this.croppaMessage = '画像を選択してください。'
    },
    update () {
      this.isLoading = true
      if (this.isImageUpdate) {
        let fname = `profile/${this.id}/profile.png`
        let encodeFname = encodeURIComponent(fname)
        let imageurl = `https://firebasestorage.googleapis.com/v0/b/heisei.appspot.com/o/${encodeFname}?alt=media`
        this.userInfo.photoURL = imageurl

        let storage = firebase.storage()
        let profileRef = storage.ref('profile')
        const path = this.id + '/profile.png'
        const imageRef = profileRef.child(path)
        this.croppa.generateBlob((blob) => {
          imageRef.put(blob)
            .then((snapshot) => {
              // 画像のURLを取得
              let storageRef = firebase.storage().ref()
              storageRef.child('profile/' + path).getDownloadURL().then((imageurl) => {
                this.$store.commit('view/setProfileImegeUrl', imageurl)
              })
            })
        })
      }
      db.collection('user').doc(this.id).set(this.userInfo)
        .then(function () {
          alert('プロフィールを更新しました。')
          this.isLoading = false
          this.$router.push({name: 'Profile', params: {id: this.id}})
        }.bind(this))
        .catch(function (error) {
          alert('エラーです。申し訳ございません。\r\n再度保存をお願いいたします。')
          console.error(error)
          this.isLoading = false
        }.bind(this))
    }
  },
  filters: {
  },
  components: {
    CommonHeader,
    CommonFooter
  }
}
</script>

<style scoped>
@import url("../../assets/css/common.css");
.wrapper{
  margin: 16px auto 0 auto;
  width: 100%;
  max-width: 700px;
}
.topIcon{
  text-align: center;
}
.form_label{
  font-weight: bold;
  font-size: 120%;
  padding-top: 15px;
  padding-right: 20px;
  text-align: right;
}
.topName{
  margin-top: 10px;
  margin-bottom: 5px;
  font-size: 120%;
}
.croppa-header{
  padding-bottom: 0 !important;
  padding-top: 0 !important;
}
.croppa-wrapper {
  margin: 40px auto 20px auto;
  width: 200px;
  height: 200px;
}
.messageArea {
  margin: 10px;
}
.croppa-compornent{
  text-align: center;
}
.headline{
  margin-top: 16px;
  margin-bottom: 10px;
}
.isLoading{
  margin: 100px auto 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/auth/EditProfile.vue